"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISITOR_VISA_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.VISITOR_VISA_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "APPLICANT_VISITOR_GETTING_STARTED_PART1",
        title: "Your Personal Information",
        subtitle: "Please confirm your full legal name and your date or birth (as shown on your passport).",
        id: 96,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Date of Birth"].label("PD_7"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_VISITOR_GETTING_STARTED_PART2",
        title: "Your Travel Information",
        subtitle: "Please complete the questions below related to your citizenship and your purpose of travel.",
        id: 97,
        content: [
            Question["What is the purpose of your visit?"].label("TR_21"),
            Question["Will you be visiting Canada for longer than 6 months?"].label("TR_11"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
            Question["Are you 18 years of age or older?"]
                .label("PD_16")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Will you be traveling to Canada with both (or all) your parent(s) or legal guardian(s)?"].label("EDU_26"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_VISITOR_GETTING_IN_CANADA_STARTED_PART2",
        title: "Your Travel Information",
        subtitle: "Please complete the questions below about your purpose of travel.",
        id: 110,
        content: [
            Question["What is the purpose of your visit?"].label("TR_21"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_VISITOR_GETTING_STARTED_PART3",
        title: "Your Family Information",
        subtitle: "You are allowed to bring immediate family members with you to Canada. If you plan on bringing family members, please add them all below.",
        id: 98,
        content: [
            Question["Are you bringing any family members (spouse, common-law partner, children) with you to Canada?"]
                .label("PD_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!"].label("CUS_1"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "APPLICANT_VISITOR_PERSONAL_DETAILS",
        id: 99,
        title: "Personal Details",
        subtitle: undefined,
        content: [
            Question["Have you ever used any other name?"]
                .label("PD_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Other first name(s)"].label("PD_4"),
                Question["Other last name(s)"].label("PD_5"),
            ]),
            Question["Sex"].label("PD_6"),
            Question["Date of Birth"].label("PD_7"),
            Question["City/Town (Place of birth)"].label("PD_8"),
            Question["Country or Territory (Place of birth)"].label("PD_9"),
            Question["Do you have a second Country of Citizenship?"]
                .label("PD_12")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Secondary Country of Citizenship"].label("PD_13"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "DETAILS_VISIT",
        id: 100,
        title: "Information about your Visit",
        subtitle: undefined,
        content: [
            Question["What day will you be arriving?"].label("TR_1"),
            Question["What day will you be leaving?"].label("TR_2"),
            Question["What is the total amount of funds you have available for your visit?"].label("TR_3"),
            Question["Who will you be visiting while you are in Canada?"].label("HEAD_10"),
            Question["Full name of person or institution"].label("TR_4"),
            Question["How do you know them?"].label("TR_5"),
            Question["What is their full address in Canada?"].label("TR_6"),
            Question["Will you be visiting anyone else in while Canada?"]
                .label("TR_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Full name of person or institution"].label("TR_8"),
                Question["How do you know them?"].label("TR_9"),
                Question["What is their full address in Canada?"].label("TR_10"),
            ]),
        ],
    }),
    // Note: This is empty because it was not created with this seed repo
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_CONTACT_INFORMATION",
        id: 95,
        title: "Contact Information",
        subtitle: undefined,
        content: [],
    }),
    // Note: This is empty because it was not created with this seed repo
    (0, group_1.group)({
        uniqueKey: "APPLICANT_STUDY_PRIMARY_ADDRESS",
        id: 94,
        title: "Primary Address",
        subtitle: undefined,
        content: [],
    }),
];
